/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

import { Module } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';
import MsDyn365 from '@msdyn365-commerce/core';
import { IInvoicesListViewProps } from '@msdyn365-commerce-modules/invoice/src/modules/invoices-list/./invoices-list';

export const InvoiceListView: React.FC<IInvoicesListViewProps> = props => {
    const { header, filter, content, invoiceRequestModal, pagination } = props;
    if (MsDyn365.isBrowser) {
        const linksElements = document.querySelectorAll('a.msc-invoices-list__container__content__table__row__open-invoice');
        console.log(linksElements);
        linksElements.forEach(l => l.setAttribute('href', '#'));
    }
    return (
        <Module {...props.moduleProps}>
            {header}
            {invoiceRequestModal}
            {filter}
            {content}
            {pagination}
        </Module>
    );
};

export default InvoiceListView;
